import type { Service } from '../exercise';

export const services: Service[] = [
  {
    title: 'Sauny',
    paragraph:
      'Moderně vybavené fitness centrum pro silový i kondiční trénink. Ideální pro začátečníky i pokročilé.',
    image: '/images/sauna/index.webp',
    url: '/sauny',
    icon: 'icon:sauna',
  },
  // {
  //   title: 'Solárium',
  //   paragraph:
  //     'Zasloužený relax po tréninku. Sauna, vířivka a profesionální masáže pro vaši regeneraci.',
  //   image: '/images/services.webp',
  //   url: '/solarium',
  // },
  {
    title: 'Masáže',
    paragraph:
      'Zasloužený relax po tréninku. Sauna, vířivka a profesionální masáže pro vaši regeneraci.',
    image: '/images/masaze/index.webp',
    url: '/masaze',
    icon: 'icon:massage',
  },
];
